@if (!innerContent) {
  <section class="search_filters_wrapper" [ngClass]="{ hide_filters_menu: !searchService.showSearchFilters() }">
    <div>
      <div class="d-flex justify-content-start align-items-end search_filter_details gap-2">
        <h3 class="xs-title bold">{{ "filters" | translate | titlecase }}</h3>
        @if (searchService.filtersCount > 0) {
          <p (click)="onResetFilter()" class="m-body medium cursor-pointer">
            {{ "delete_all" | translate: { filtersCount: searchService.filtersCount } }}
          </p>
        }
      </div>
      @if (searchService.appliedFilters().length > 0) {
        <div class="filters_types_wrappers">
          @for (filter of searchService.appliedFilters(); track filter) {
            <div class="filter_type">
              <span>{{ filter.label | translate | titlecase }}</span>
              <app-icon icon="xmark" class="cursor-pointer" (click)="resetFilterType(filter.filter_type, filter.label)">
              </app-icon>
            </div>
          }
        </div>
      }
    </div>
    <div class="med_filter-options">
      <mat-accordion multi>
        <!-- Connectors filter -->
        <mat-expansion-panel class="mat-elevation-z0 expansion_panel" [expanded]="true">
          <mat-expansion-panel-header class="filter_according_header top-border">
            <mat-panel-title class="filter_accordion_title">
              <h4 class="xs-title">{{ "connectors" | translate | titlecase }}</h4>
              @if (searchService.getFilterTypeCount("connectors") > 0) {
                <span class="badge">{{ searchService.getFilterTypeCount("connectors") }}</span>
                <app-icon
                  icon="trash-can"
                  class="clear_filter_type"
                  (click)="clearConnectorFilter(); $event.stopPropagation()"
                ></app-icon>
              }
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ul class="filter_menu_items">
            @for (
              connector of searchService.connectors()
                | slice: 0 : displayedConnectors
                | filterOptions: ["name"] : sourceFilter;
              track connector;
              let j = $index
            ) {
              <li class="d-flex align-items-center justify-content-between w-100">
                <div class="label_wrapper">
                  <div class="d-flex justify-content-start align-items-center">
                    <mat-checkbox
                      [id]="connector.name + j"
                      [name]="connector.name"
                      [checked]="connector.checked"
                      (click)="$event.stopPropagation()"
                      (change)="toggleConnector(connector)"
                    >
                    </mat-checkbox>
                    <button
                      class="m-body filter_type cursor-pointer"
                      (click)="toggleConnector(connector); $event.stopPropagation()"
                    >
                      {{ connector.name }}
                    </button>
                  </div>
                  <p class="m-body bold source_count ps-2">
                    {{ searchService.getConnectorResultsCount(connector.name, true) }}
                  </p>
                </div>
              </li>
            }
            @if (searchService.connectors().length > maxDisplayed) {
              <li class="show_more_li">
                <button class="show_more" (click)="toggleShowMoreConnectors()">
                  {{ (displayedConnectors > maxDisplayed ? "less" : "show") | translate }}
                </button>
              </li>
            }
          </ul>
        </mat-expansion-panel>
        <!-- #Connectors filter -->

        <!-- Type code filter -->
        <mat-expansion-panel class="mat-elevation-z0 expansion_panel" [expanded]="true">
          <mat-expansion-panel-header class="filter_according_header top-border">
            <mat-panel-title class="filter_accordion_title">
              <h4 class="xs-title">{{ "result_connector_type" | translate | titlecase }}</h4>
              @if (searchService.getFilterTypeCount("type_code") > 0) {
                <span class="badge">{{ searchService.getFilterTypeCount("type_code") }}</span>
                <app-icon
                  icon="trash-can"
                  class="clear_filter_type"
                  (click)="clearTypeCodeFilter(); $event.stopPropagation()"
                ></app-icon>
              }
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ul class="filter_menu_items">
            @for (
              typeCode of searchService.typeCodes() | slice: 0 : displayedResultType;
              track typeCode;
              let i = $index
            ) {
              <li class="d-flex align-items-center justify-content-between w-100">
                <div class="label_wrapper">
                  <div class="d-flex justify-content-start align-items-center">
                    <mat-checkbox
                      [id]="typeCode.value + i"
                      [checked]="typeCode.checked"
                      (click)="$event.stopPropagation()"
                      (change)="toggleTypeCode(typeCode)"
                    >
                    </mat-checkbox>
                    <button
                      class="m-body filter_type cursor-pointer"
                      (click)="toggleTypeCode(typeCode); $event.stopPropagation()"
                    >
                      {{ typeCode.label | titlecase }}
                    </button>
                  </div>
                  <p class="m-body bold source_count ps-2">
                    {{ searchService.getCountForTypeCodeCount(typeCode.value, false) }}
                  </p>
                </div>
              </li>
            }
            @if (searchService.typeCodes().length > maxDisplayed) {
              <li class="show_more_li">
                <button class="show_more" (click)="toggleShowMoreTypeCode()">
                  {{ (displayedResultType > maxDisplayed ? "less" : "show") | translate }}
                </button>
              </li>
            }
          </ul>
        </mat-expansion-panel>
        <!-- #Type code filter -->

        <!-- File type/Result type filter -->
        @if (searchService.fileTypes().length > 0) {
          <mat-expansion-panel class="mat-elevation-z0 expansion_panel" [expanded]="true">
            <mat-expansion-panel-header class="filter_according_header top-border">
              <mat-panel-title class="filter_accordion_title">
                <h4 class="xs-title">{{ "file_type" | translate | titlecase }}</h4>
                @if (searchService.getFilterTypeCount("result_type") > 0) {
                  <span class="badge">{{ searchService.getFilterTypeCount("result_type") }}</span>
                  <app-icon icon="trash-can" class="clear_filter_type" (click)="clearFileTypeFilter()"></app-icon>
                }
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ul class="filter_menu_items">
              @for (
                fileType of searchService.fileTypes() | slice: 0 : displayedResultType;
                track fileType;
                let i = $index
              ) {
                <li class="d-flex align-items-center justify-content-between w-100">
                  <div class="label_wrapper">
                    <div class="d-flex justify-content-start align-items-center">
                      <mat-checkbox
                        [id]="fileType.type + i"
                        [checked]="fileType.checked"
                        (click)="$event.stopPropagation()"
                        (change)="toggleFileType(fileType)"
                      >
                      </mat-checkbox>
                      <button
                        class="m-body filter_type cursor-pointer"
                        (click)="toggleFileType(fileType); $event.stopPropagation()"
                      >
                        {{ fileType.type | titlecase }}
                      </button>
                    </div>
                    <p class="m-body bold source_count ps-2">
                      {{ searchService.getCountForFileType(fileType.type, false) }}
                    </p>
                  </div>
                </li>
              }
              @if (searchService.fileTypes().length > maxDisplayed) {
                <li class="show_more_li">
                  <button class="show_more" (click)="toggleShowMoreResultType()">
                    {{ (displayedResultType > maxDisplayed ? "less" : "show") | translate }}
                  </button>
                </li>
              }
            </ul>
          </mat-expansion-panel>
        }
        <!-- #File type/Result type filter -->

        <!-- Date filter -->
        <mat-expansion-panel class="mat-elevation-z0 expansion_panel" [expanded]="true">
          <mat-expansion-panel-header class="filter_according_header top-border">
            <mat-panel-title class="filter_accordion_title">
              <h4 class="xs-title">{{ "date" | translate | titlecase }}</h4>
              @if (searchService.getFilterTypeCount("date") > 0) {
                <span class="badge">{{ searchService.getFilterTypeCount("date") }}</span>
                <app-icon
                  icon="trash-can"
                  class="clear_filter_type"
                  (click)="clearDateFilter(); $event.stopPropagation()"
                ></app-icon>
              }
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div (click)="$event.stopPropagation()" class="date_item">
            <mat-label>{{ "start_date" | translate }}</mat-label>
            <div class="date_picker_wrapper">
              <input
                [(ngModel)]="searchService.selectedDateRange().start"
                matInput
                [matDatepicker]="datepickerFrom"
                (click)="$event.stopPropagation()"
                readonly="true"
                placeholder="MM/DD/YYYY"
              />
              <mat-datepicker-toggle matIconSuffix [for]="datepickerFrom"></mat-datepicker-toggle>
            </div>

            <mat-datepicker #datepickerFrom>
              <mat-datepicker-actions>
                <button matDatepickerCancel>{{ "cancel" | translate | titlecase }}</button>
                <button class="okay_btn" matDatepickerApply (click)="onSelectedChange()">
                  {{ "ok" | translate | titlecase }}
                </button>
              </mat-datepicker-actions>
            </mat-datepicker>
          </div>

          <div (click)="$event.stopPropagation()" class="date_item">
            <mat-label>{{ "end_date" | translate }}</mat-label>
            <div class="date_picker_wrapper">
              <input
                [disabled]="!searchService.selectedDateRange().start"
                [min]="searchService.selectedDateRange().start"
                [(ngModel)]="searchService.selectedDateRange().end"
                matInput
                [matDatepicker]="datepickerTo"
                (click)="$event.stopPropagation()"
                readonly="true"
                placeholder="MM/DD/YYYY"
              />
              <mat-datepicker-toggle matIconSuffix [for]="datepickerTo"></mat-datepicker-toggle>
            </div>
            <mat-datepicker #datepickerTo>
              <mat-datepicker-actions>
                <button matDatepickerCancel>{{ "cancel" | translate | titlecase }}</button>
                <button class="okay_btn" matDatepickerApply (click)="onSelectedChange()">
                  {{ "ok" | translate | titlecase }}
                </button>
              </mat-datepicker-actions>
            </mat-datepicker>
          </div>
          <div class="dates_list" (click)="$event.stopPropagation()">
            @for (presetDate of searchService.presetDateFilters; track presetDate) {
              <button
                class="filter_dates_btn"
                [ngClass]="{ selected: searchService.selectedPresetDate() === presetDate.value }"
                (click)="onPresetDateChange(presetDate.value)"
              >
                {{ presetDate.label }}
              </button>
            }
          </div>
        </mat-expansion-panel>
        <!-- #Date filter -->
      </mat-accordion>
    </div>
  </section>
}

<!-- form modal inner content -->
@if (innerContent) {
  <section class="search-results-filter-mobile">
    <div class="filters_types_wrappers d-flex flex-column just-content-center align-items-start gap-3">
      @if (searchService.filtersCount > 0) {
        <button (click)="onResetFilter()" class="delete_btn mt-4">
          {{ "delete_all" | translate: { filtersCount: searchService.filtersCount } }}
        </button>
      }
      <div class="d-flex align-items-center justify-content-start gap-2 flex-wrap">
        @for (filter of searchService.appliedFilters(); track filter) {
          <div class="filter_type">
            <span>{{ filter.label | translate | titlecase }}</span>
            <app-icon icon="xmark" class="cursor-pointer" (click)="resetFilterType(filter.filter_type, filter.label)">
            </app-icon>
          </div>
        }
      </div>
    </div>

    <mat-accordion multi>
      <!-- Connectors filter -->
      <mat-expansion-panel class="mat-elevation-z0 expansion_panel" [expanded]="true">
        <mat-expansion-panel-header
          class="filter_according_header"
          [ngClass]="{ 'top-border': searchService.appliedFilters().length > 0 || deviceType.isDesktop }"
        >
          <mat-panel-title class="filter_accordion_title">
            <h4 class="xs-title">{{ "connectors" | translate | titlecase }}</h4>
            @if (searchService.getFilterTypeCount("connectors") > 0) {
              <span class="badge">{{ searchService.getFilterTypeCount("connectors") }}</span>
              <app-icon
                icon="trash-can"
                class="clear_filter_type"
                (click)="clearConnectorFilter(); $event.stopPropagation()"
              ></app-icon>
            }
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ul class="filter_menu_items">
          @for (
            connector of searchService.connectors()
              | slice: 0 : displayedConnectors
              | filterOptions: ["name"] : sourceFilter;
            track connector;
            let j = $index
          ) {
            <li class="d-flex align-items-center justify-content-between w-100">
              <div class="label_wrapper">
                <div class="d-flex justify-content-start align-items-center">
                  <mat-checkbox
                    [id]="connector.name + j"
                    [name]="connector.name"
                    [checked]="connector.checked"
                    (click)="$event.stopPropagation()"
                    (change)="toggleConnector(connector)"
                  >
                  </mat-checkbox>
                  <button
                    class="m-body filter_type cursor-pointer"
                    (click)="toggleConnector(connector); $event.stopPropagation()"
                  >
                    {{ connector.name }}
                  </button>
                </div>
                <p class="m-body bold source_count ps-2">
                  {{ searchService.getConnectorResultsCount(connector.name, false) }}
                </p>
              </div>
            </li>
          }
          @if (searchService.connectors().length > maxDisplayed) {
            <li class="show_more_li">
              <button class="show_more" (click)="toggleShowMoreConnectors()">
                {{ (displayedConnectors > maxDisplayed ? "less" : "show") | translate }}
              </button>
            </li>
          }
        </ul>
      </mat-expansion-panel>
      <!-- #Connectors filter -->

      <!-- Type code filter -->
      <mat-expansion-panel class="mat-elevation-z0 expansion_panel" [expanded]="true">
        <mat-expansion-panel-header class="filter_according_header top-border">
          <mat-panel-title class="filter_accordion_title">
            <h4 class="xs-title">{{ "result_connector_type" | translate | titlecase }}</h4>
            @if (searchService.getFilterTypeCount("type_code") > 0) {
              <span class="badge">{{ searchService.getFilterTypeCount("type_code") }}</span>
              <app-icon
                icon="trash-can"
                class="clear_filter_type"
                (click)="clearTypeCodeFilter(); $event.stopPropagation()"
              ></app-icon>
            }
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ul class="filter_menu_items">
          @for (
            typeCode of searchService.typeCodes() | slice: 0 : displayedResultType;
            track typeCode;
            let i = $index
          ) {
            <li class="d-flex align-items-center justify-content-between w-100">
              <div class="label_wrapper">
                <div class="d-flex justify-content-start align-items-center">
                  <mat-checkbox
                    [id]="typeCode.value + i"
                    [checked]="typeCode.checked"
                    (click)="$event.stopPropagation()"
                    (change)="toggleTypeCode(typeCode)"
                  >
                  </mat-checkbox>
                  <button
                    class="m-body filter_type cursor-pointer"
                    (click)="toggleTypeCode(typeCode); $event.stopPropagation()"
                  >
                    {{ typeCode.label | titlecase }}
                  </button>
                </div>
                <p class="m-body bold source_count ps-2">
                  {{ searchService.getCountForTypeCodeCount(typeCode.value, true) }}
                </p>
              </div>
            </li>
          }
          @if (searchService.typeCodes().length > maxDisplayed) {
            <li class="show_more_li">
              <button class="show_more" (click)="toggleShowMoreTypeCode()">
                {{ (displayedResultType > maxDisplayed ? "less" : "show") | translate }}
              </button>
            </li>
          }
        </ul>
      </mat-expansion-panel>
      <!-- #Type code filter -->

      <!-- File type/Result type filter -->
      @if (searchService.fileTypes().length > 0) {
        <mat-expansion-panel class="mat-elevation-z0 expansion_panel" [expanded]="true">
          <mat-expansion-panel-header class="filter_according_header top-border">
            <mat-panel-title class="filter_accordion_title">
              <h4 class="xs-title">{{ "file_type" | translate | titlecase }}</h4>
              @if (searchService.getFilterTypeCount("result_type") > 0) {
                <span class="badge">{{ searchService.getFilterTypeCount("result_type") }}</span>
                <app-icon icon="trash-can" class="clear_filter_type" (click)="clearFileTypeFilter()"></app-icon>
              }
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ul class="filter_menu_items">
            @for (
              fileType of searchService.fileTypes() | slice: 0 : displayedResultType;
              track fileType;
              let i = $index
            ) {
              <li class="d-flex align-items-center justify-content-between w-100">
                <div class="label_wrapper">
                  <div class="d-flex justify-content-start align-items-center">
                    <mat-checkbox
                      [id]="fileType.type + i"
                      [checked]="fileType.checked"
                      (click)="$event.stopPropagation()"
                      (change)="toggleFileType(fileType)"
                    >
                    </mat-checkbox>
                    <button
                      class="m-body filter_type cursor-pointer"
                      (click)="toggleFileType(fileType); $event.stopPropagation()"
                    >
                      {{ fileType.type | titlecase }}
                    </button>
                  </div>
                  <p class="m-body bold source_count ps-2">
                    {{ searchService.getCountForFileType(fileType.type, true) }}
                  </p>
                </div>
              </li>
            }
            @if (searchService.fileTypes().length > maxDisplayed) {
              <li class="show_more_li">
                <button class="show_more" (click)="toggleShowMoreResultType()">
                  {{ (displayedResultType > maxDisplayed ? "less" : "show") | translate }}
                </button>
              </li>
            }
          </ul>
        </mat-expansion-panel>
      }
      <!-- #File type/Result type filter -->

      <!-- Date filter -->
      <mat-expansion-panel class="mat-elevation-z0 expansion_panel ps-0" [expanded]="true">
        <mat-expansion-panel-header class="filter_according_header top-border">
          <mat-panel-title class="filter_accordion_title">
            <h4 class="xs-title">{{ "date" | translate | titlecase }}</h4>
            @if (searchService.getFilterTypeCount("date") > 0) {
              <span class="badge">{{ searchService.getFilterTypeCount("date") }}</span>
              <app-icon
                icon="trash-can"
                class="clear_filter_type"
                (click)="clearDateFilter(); $event.stopPropagation()"
              ></app-icon>
            }
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="d-flex justify-content-between align-items-start gap-3 px-3">
          <div (click)="$event.stopPropagation()" class="date_item">
            <mat-label>{{ "start_date" | translate }}</mat-label>
            <div class="date_picker_wrapper">
              <input
                [(ngModel)]="searchService.selectedDateRange().start"
                matInput
                [matDatepicker]="datepickerFrom"
                (click)="$event.stopPropagation()"
                readonly="true"
                placeholder="MM/DD/YYYY"
              />
              <mat-datepicker-toggle matIconSuffix [for]="datepickerFrom"></mat-datepicker-toggle>
            </div>

            <mat-datepicker #datepickerFrom>
              <mat-datepicker-actions>
                <button matDatepickerCancel>{{ "cancel" | translate | titlecase }}</button>
                <button class="okay_btn" matDatepickerApply (click)="onSelectedChange()">
                  {{ "ok" | translate }}
                </button>
              </mat-datepicker-actions>
            </mat-datepicker>
          </div>

          <div (click)="$event.stopPropagation()" class="date_item">
            <mat-label>{{ "end_date" | translate }}</mat-label>
            <div class="date_picker_wrapper">
              <input
                [disabled]="!searchService.selectedDateRange().start"
                [min]="searchService.selectedDateRange().start"
                [(ngModel)]="searchService.selectedDateRange().end"
                matInput
                [matDatepicker]="datepickerTo"
                (click)="$event.stopPropagation()"
                readonly="true"
                placeholder="MM/DD/YYYY"
              />
              <mat-datepicker-toggle matIconSuffix [for]="datepickerTo"></mat-datepicker-toggle>
            </div>
            <mat-datepicker #datepickerTo>
              <mat-datepicker-actions>
                <button matDatepickerCancel>{{ "cancel" | translate | titlecase }}</button>
                <button class="okay_btn" matDatepickerApply (click)="onSelectedChange()">{{ "ok" | translate }}</button>
              </mat-datepicker-actions>
            </mat-datepicker>
          </div>
        </div>
        <div class="dates_list" (click)="$event.stopPropagation()">
          @for (presetDate of searchService.presetDateFilters; track presetDate) {
            <button
              class="filter_dates_btn"
              [ngClass]="{ selected: searchService.selectedPresetDate() === presetDate.value }"
              (click)="onPresetDateChange(presetDate.value)"
            >
              {{ presetDate.label }}
            </button>
          }
        </div>
      </mat-expansion-panel>
      <!-- #Date filter -->
    </mat-accordion>
  </section>
}
<!-- end form modal inner content -->
